<script>
export default {
	name: 'App'
}
</script>

<template>
	<div id="app">
		<div id="content">
			<transition name="fade">
				<router-view />
			</transition>
		</div>
	</div>
</template>

<style>
	/* @import url('https://fonts.googleapis.com/css?family=Lato:100,300,400,700'); */
	/* @import url('https://fonts.googleapis.com/css?family=Raleway:100,300,400,700'); */
	/* @import url('https://fonts.googleapis.com/css?family=Montserrat:100,300,400,700'); */
	/* @import url('https://fonts.googleapis.com/css?family=Kalam:100,300,400,700'); */
	/* @import url('https://fonts.googleapis.com/css?family=Sniglet:400,800'); */
	/* @import url('https://fonts.googleapis.com/css?family=Gaegu:300,700'); */
	/* @import url('https://fonts.googleapis.com/css?family=Indie+Flower:100,300,400,700'); */
	/* @import url('https://fonts.googleapis.com/css?family=Atma:100,300,400,700'); */
	/* @import url('https://fonts.googleapis.com/css?family=Shadows+Into+Light+Two:100,300,400,700'); */
	/* @import url('https://fonts.googleapis.com/css?family=Gloria+Hallelujah:100,300,400,700'); */

	@import url('https://fonts.googleapis.com/css?family=Roboto:300');
	@import url('https://fonts.googleapis.com/css?family=Caveat:400');
	@import url('https://fonts.googleapis.com/css?family=Amatic+SC:400,700');

	/*** Normalize ***/

	* {
		box-sizing: border-box;
	}

	a {
		color: inherit;
		text-decoration: none;
		outline: none;
	}

	/*** Layout ***/

	html, body {
		margin: 0;
		padding: 0;
	}

	/* always fill the window */
	html, body {
		min-height: 100%;
	}

	/* scroll the html rather than the body so the body background span full height (and not full viewport height) */
	/* set vertical scrollbar always visible to avoid jumps when changing view */
	html {
		overflow-x: hidden;
		overflow-y: scroll;
	}
	
	#app {
		/* app div centered */	
		max-width: 1280px;
		margin: 0 auto;
		/* with some padding */
		padding: 0 3%;
	}
	#content {
		/* intermediate div to allow absolute positioning of views without taking up app padding space */
		position: relative;
	}

	/*** View transition ***/

	.fade-enter-active, .fade-leave-active {
		transition: opacity .3s;
	}
	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
	.fade-leave-active {
		/* so both previous and next views overlap during the transition */
		position: absolute;
		width: 100%;
	}

	/*** Theme ***/
	
	body {
		--app-font-header: 400 1em/1em 'Amatic SC', cursive;
		--app-font-title: 400 1em/1.1em 'Caveat', cursive;
		--app-font-text: 300 1em/1.4em 'Roboto', sans-serif;
		font: var(--app-font-text);
	}

	body {
		background:
			/* white gradient on top behind header */
			linear-gradient(to bottom, rgba(255,255,255,.2), transparent 150px),
			/* dark gradient to dim the image and hide its bottom limit (with a width-relative measurement because the background image size depends of the screen width) */
			linear-gradient(to bottom, rgba(51,51,51,.8), rgb(51,51,51) 66vw),
			/* image */
			url('assets/bg1.jpg');
		background-repeat: no-repeat;
		background-size: 100%;
	}
	
	/*** Responsive ***/

	@media screen and (max-width: 768px) {
		body {
			font-size: 90%;
		}
	}

	@media screen and (max-width: 425px) {
		#app {
			padding: 0;
		}
		body {
			font-size: 80%;
		}
	}

</style>

<style>

	/*** Bubble hover effect ***/

	a.bubble {
		display: inline-block;
		position: relative;
	}
	a.bubble::after {
		content: '';
		position: absolute;
		left: 50%;
		top: 50%;
		width: 100%;
		padding-top: 100%;
		border-radius: 100%;
		z-index: -1;
		transform: translate(-50%, -50%) scale(var(--bubble-scale, 1));
		opacity: var(--bubble-opacity, 0);
		background-color: var(--bubble-color);
		transition: all .3s;
	}
	a.bubble:not(:active):hover::after,
	a.bubble:not(:active):focus::after {
		transform: translate(-50%, -50%) scale(var(--bubble-scale-active, 1.2));
		opacity: var(--bubble-opacity-active, var(--bubble-opacity, .1));
		background-color: var(--bubble-color-active, var(--bubble-color, #000));
	}

	/*** Ripple click effect ***/

	a.ripple {
		display: inline-block;
		position: relative;
	}
	a.ripple::before {
		content: '';
		position: absolute;
		left: 50%;
		top: 50%;
		width: 100%;
		padding-top: 100%;
		border-radius: 100%;
		z-index: -1;
		transform: translate(-50%, -50%) scale(var(--ripple-scale, 1));
		opacity: var(--ripple-opacity, 1);
		background-color: var(--ripple-color, transparent);
		
	}
	a.ripple:active::before {
		transition: all .3s;
		transform: translate(-50%, -50%) scale(var(--ripple-scale-active, 1.5));
		opacity: var(--ripple-opacity-active, var(--ripple-opacity, 0));
		background-color: var(--ripple-color-active, var(--ripple-color, #000));
	}
</style>

